/* ============================================================
   PURETREX — PDP v2 buy box
   Purchase mode, quantity, live pricing, sticky bar, gallery.
   No dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* The shop's own money format comes in with the price payload, so the
     currency symbol always matches the store (£ in the UK). */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function perDay(cents, days, fmt) {
    if (!days) return '';
    return money(Math.round(cents / days), fmt) + '/day';
  }

  function init(root) {
    if (!root || root.__ptx2) return;
    root.__ptx2 = true;

    var holder = root.querySelector('[data-ptx2-data]');
    var d;
    try { d = JSON.parse(holder.textContent); }
    catch (e) { if (window.console) console.warn('PTX v2: bad price payload', e); return; }

    var fmt = d.moneyFormat || (window.Shopify && window.Shopify.money_format) || '{{amount}}';

    var qtyField  = root.querySelector('[data-ptx2-qtyfield]');
    var planField = root.querySelector('[data-ptx2-planfield]');
    var opts      = [].slice.call(root.querySelectorAll('[data-ptx2-opt]'));
    var tiers     = [].slice.call(root.querySelectorAll('[data-ptx2-tier]'));
    var freqs     = [].slice.call(root.querySelectorAll('[data-ptx2-freq]'));
    var atcText   = root.querySelector('[data-ptx2-atctext]');

    /* Match the section's preferred delivery frequency by name, so a
       60-day pouch defaults to the two-monthly plan rather than the
       first one Appstle happens to return. */
    function preferredPlan() {
      if (!d.plans || !d.plans.length) return null;
      var want = String(d.preferredPlan || '').toLowerCase().trim();
      if (want) {
        for (var i = 0; i < d.plans.length; i++) {
          if (String(d.plans[i].name || '').toLowerCase().indexOf(want) !== -1) return d.plans[i];
        }
      }
      return d.plans[0];
    }

    var plan = preferredPlan();
    var state = { mode: 'one', tier: 0 };

    function planById(id) {
      for (var i = 0; i < (d.plans || []).length; i++) {
        if (String(d.plans[i].id) === String(id)) return d.plans[i];
      }
      return null;
    }
    function pctOff(pl) {
      if (!pl || !d.base) return 0;
      return Math.round((1 - pl.price / d.base) * 100);
    }
    /* A readable delivery label from the Appstle plan name:
       "Month" -> "every month", "2 Months" -> "every 2 months". */
    function plural(word, n) {
      if (n === 1) return word;
      var w = String(word || 'pouch');
      return /(ch|sh|s|x|z)$/i.test(w) ? w + 'es' : w + 's';
    }
    function everyLabel(pl) {
      var n = String(pl && pl.name || '').trim().toLowerCase();
      if (!n) return '';
      return 'every ' + n;
    }

    /* Tier facts live on the markup, so the theme editor stays the single
       source of truth for quantity and discount. */
    function tierAt(i) {
      var el = tiers[i];
      if (!el) return { qty: 1, pct: 0 };
      return {
        qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
        pct: parseInt(el.getAttribute('data-pct'), 10) || 0
      };
    }
    function current() { return tierAt(state.tier); }

    function unit() {
      return (state.mode === 'sub' && plan) ? plan.price : d.base;
    }
    /* A quantity discount applies to one-time orders only. Subscription
       pricing is whatever the Appstle plan charges, never stacked. */
    function priceFor(qty, pct) {
      var gross = unit() * qty;
      if (state.mode === 'sub' || !pct) return gross;
      return gross - Math.round(gross * pct / 100);
    }
    function total() {
      var t = current();
      return priceFor(t.qty, t.pct);
    }

    function render() {
      var cur = current();
      if (qtyField) qtyField.value = cur.qty;
      if (planField) planField.value = (state.mode === 'sub' && plan) ? plan.id : '';

      opts.forEach(function (o) {
        var on = o.getAttribute('data-ptx2-opt') === state.mode;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      /* Both option cards price the quantity the customer actually picked,
         so the two lines compare like with like. */
      var oneNet = d.base * cur.qty;
      if (cur.pct) oneNet = oneNet - Math.round(oneNet * cur.pct / 100);
      var oneEl = root.querySelector('[data-ptx2-price-one]');
      if (oneEl) oneEl.textContent = money(oneNet, fmt);

      if (plan) {
        var subEl = root.querySelector('[data-ptx2-price-sub]');
        if (subEl) subEl.textContent = money(plan.price * cur.qty, fmt);
        var wasEl = root.querySelector('[data-ptx2-was-sub]');
        if (wasEl) wasEl.textContent = plan.price < d.base ? money(d.base * cur.qty, fmt) : '';
        var pill = root.querySelector('[data-ptx2-pill]');
        if (pill) {
          var off = pctOff(plan);
          pill.textContent = off > 0 ? ('SAVE ' + off + '%') : '';
          pill.style.display = off > 0 ? '' : 'none';
        }
        var subMeta = root.querySelector('[data-ptx2-meta-sub]');
        if (subMeta && d.days) {
          var note = document.createElement('span');
          note.textContent = 'Delivered ' + everyLabel(plan);
          var pd = document.createElement('span');
          pd.className = 'nw';
          pd.textContent = '\u00b7 ' + perDay(plan.price * cur.qty, d.days * cur.qty, fmt);
          subMeta.textContent = '';
          subMeta.appendChild(note);
          subMeta.appendChild(document.createTextNode(' '));
          subMeta.appendChild(pd);
        }
      }

      freqs.forEach(function (f) {
        var pl = planById(f.getAttribute('data-ptx2-freq'));
        var on = plan && String(pl && pl.id) === String(plan.id);
        f.classList.toggle('is-active', !!on);
        f.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      tiers.forEach(function (el, i) {
        var on = i === state.tier;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      /* Quantity meta: supply length, plus the saving once a real
         quantity discount is set (one-time only, never stacked). */
      var qm = root.querySelector('[data-ptx2-qtymeta]');
      if (qm) {
        var parts = [];
        if (d.days) parts.push((d.days * cur.qty) + '-day supply');
        if (state.mode !== 'sub' && cur.pct > 0) {
          var g = d.base * cur.qty;
          parts.push('Save ' + money(g - priceFor(cur.qty, cur.pct), fmt));
        }
        qm.textContent = parts.join(' \u00b7 ');
      }

      var more = root.querySelector('[data-ptx2-submore]');
      if (more) more.hidden = state.mode !== 'sub';

      if (atcText) {
        atcText.textContent = d.available === false
          ? (d.soldOutLabel || 'Sold out')
          : (d.atcLabel || 'Add to cart') + ' · ' + money(total(), fmt);
      }
      var pdEl = root.querySelector('[data-ptx2-perday]');
      if (pdEl && d.days) pdEl.textContent = perDay(total(), d.days * cur.qty, fmt);
      [].slice.call(document.querySelectorAll('[data-ptx2-remote-price]')).forEach(function (el) {
        el.textContent = d.available === false ? '' : '\u00b7 ' + money(total(), fmt);
      });
      var sp = document.querySelector('[data-ptx2-sticky-price]');
      if (sp) {
        sp.textContent = money(total(), fmt) + (d.days ? (' · ' + (d.days * cur.qty) + ' days') : '');
      }
    }

    /* Purchase options behave as a radio group: click, Space/Enter to pick,
       arrow keys to move between the options. */
    function pickOpt(i, focus) {
      var o = opts[(i + opts.length) % opts.length];
      state.mode = o.getAttribute('data-ptx2-opt');
      render();
      if (focus) o.focus();
    }
    opts.forEach(function (o, i) {
      o.addEventListener('click', function () { pickOpt(i); });
      o.addEventListener('keydown', function (e) {
        if (e.target !== o) return;
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pickOpt(i); }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); pickOpt(i + 1, true); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); pickOpt(i - 1, true); }
      });
    });
    function pickTier(i) { state.tier = i; render(); }
    freqs.forEach(function (f) {
      f.addEventListener('click', function (e) {
        e.stopPropagation();
        var pl = planById(f.getAttribute('data-ptx2-freq'));
        if (!pl) return;
        plan = pl;
        state.mode = 'sub';
        render();
      });
    });
    tiers.forEach(function (el, i) {
      el.addEventListener('click', function () { pickTier(i); });
      el.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pickTier(i); }
      });
    });

    render();

    /* gallery */
    var stage = root.querySelector('[data-ptx2-stage]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-ptx2-thumb]'));
    if (stage && thumbs.length) {
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          var slide = stage.children[i];
          if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
          thumbs.forEach(function (o, j) { o.classList.toggle('is-active', j === i); });
        });
      });
      var timer = null;
      stage.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var idx = Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth));
          thumbs.forEach(function (o, j) { o.classList.toggle('is-active', j === idx); });
        }, 80);
      }, { passive: true });
    }

    /* Sticky bar shows once the real button has scrolled above the viewport.
       A scroll listener throttled to one frame is used instead of an
       IntersectionObserver: an observer only reports state *changes*, so a
       fast fling that jumps the button straight from below the fold to above
       it never fires, and the bar would stay hidden. */
    var bar = document.querySelector('[data-ptx2-sticky]');
    var atc = root.querySelector('[data-ptx2-atc]');
    if (bar && atc) {
      var ticking = false;
      var lastShow = null;
      function checkBar() {
        ticking = false;
        var r = atc.getBoundingClientRect();
        var show = r.bottom < 0;
        if (show !== lastShow) {
          lastShow = show;
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      }
      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(checkBar); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      checkBar();
    }
    var barBtn = bar && bar.querySelector('[data-ptx2-stickybtn]');
    if (barBtn && d.available === false) {
      barBtn.disabled = true;
      barBtn.textContent = d.soldOutLabel || 'Sold out';
    }
    if (barBtn && atc) {
      barBtn.addEventListener('click', function () {
        if (d.available === false || atc.disabled) return;
        var form = atc.form || root.querySelector('form');
        if (form && form.requestSubmit) form.requestSubmit(atc);
        else atc.click();
      });
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-ptx2-buybox]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
